<header class="header" [ngClass]="{
  'header--with-title-links': links()?.length || title(), auth: user?.auth
}">
  <div class="container">
    <div class="content-container">
      <div class="left">
        <div class="menu" (click)="sidebar.open()">
          <span></span>
          <span></span>
          <span></span>
          @if (!sidebar.isOpenedCasinoToday() && badge?.gameBadgeAllowance()) {
            <i class="badge-notif"></i>
          }
        </div>

        @if (!title()) {
          <div class="nav">
            <a class="nav__item" [routerLink]="['/' + lang.currentRouteLanguage, 'games']">{{'link.games' | translate}}</a>
            @if (user.auth) {
              <a class="nav__item"
              [routerLink]="['/' + lang.currentRouteLanguage, 'games', 'favorite']">{{'link.favorite-games' | translate}}</a>
              <a class="nav__item"
              [routerLink]="['/' + lang.currentRouteLanguage, 'games', 'last-played']">{{'link.last-played' | translate}}</a>
              <a class="nav__item"
              [routerLink]="['/' + lang.currentRouteLanguage, 'tournaments']">{{'link.tournaments' | translate}}</a>
            }
          </div>
        } @else {
          <h1 class="header__title">{{ title() | translate }}</h1>
        }

        <div class="notify mobile">
          @if (!isDesktop()) {
            <app-notification-center-drop-down *appShellNoSSR></app-notification-center-drop-down>
          }
        </div>
      </div>

      <div class="center"
        [ngClass]="{auth: user.auth}"
        >
        <a class="logo" [routerLink]="['/' + lang.currentRouteLanguage]">
          <ng-container *ngTemplateOutlet="selectLogo"></ng-container>
        </a>
      </div>

      <div class="right">
        @if (!user.auth) {
          <app-header-login-form></app-header-login-form>
        }
        @if (user.auth) {
          @if (!links()?.length) {
            <app-header-balance></app-header-balance>
          } @else {
            <div class="right-nav">
              @for (link of links(); track $index) {
                <a class="right-nav__item" routerLinkActive="active"
                  [title]="link.tab | translate" [routerLink]="'/' + lang.currentRouteLanguage + link.url">
                  <img loading="lazy" [src]="link.img" alt="">
                  <div class="right-nav__item-label">{{link.tab | translate}}</div>
                </a>
              }
            </div>
          }
          <div class="notify desktop">
            @if (isDesktop()) {
              <app-notification-center-drop-down *appShellNoSSR></app-notification-center-drop-down>
            }
          </div>
        }

      </div>
    </div>
  </div>
</header>

<ng-template #selectLogo>
  @if (xmas.store.page && !xmas.store.page.isDisablePromo) {
    <div class="cursor-pointer" [routerLink]="['/', lang.current]" (click)="sidebar.close()">
      <img [height]="28" width="80" class="logo__img xmas" src="/assets/img/promo/xmas/logo.png" alt="Spin Samurai Casino">
      <img [height]="28" width="100" class="logo__img desktop" src="/assets/img/promo/xmas/logo.png" alt="Spin Samurai Casino">
    </div>
  } @else {
    <img [height]="35" width="85" class="logo__img" src="/assets/img/logo.png" alt="Spin Samurai Casino">
    <img [height]="40" width="100" class="logo__img desktop" src="/assets/img/logo.png" alt="Spin Samurai Casino">
  }
</ng-template>
